import SecureLS from "secure-ls";

const ls = new SecureLS({
  encodingType: "aes",
  isCompression: false,
});

export const saveToken = (token: string): void => {
  ls.set("jwtToken", token);
};

export const getToken = (): string | null => {
  const token = ls.get("jwtToken");

  return typeof token === "string" ? token : null;
};

export const removeToken = (): void => {
  ls.remove("jwtToken");
};

export const saveUser = <T>(user: T): void => {
  ls.set("userInfo", user);
};

export const getUser = <T>(): T | null => {
  const user = ls.get("userInfo");

  return user ? (user as T) : null;
};

export const removeUser = (): void => {
  ls.remove("userInfo");
};
